import { Component, OnInit, Input } from '@angular/core';

import { Simulation } from '@classes/simulation/simulation';
import { AuthUser } from '@classes/auth/auth-user';
import { ReportService } from '@services/report.service';
import { AuthService } from '@services/auth.service';
import { NavService } from '@services/nav.service';
import { NavLink } from '@classes/nav-link';
import { SimulationFlagType } from '@enums/simulation-flag-type.enum';
import { PartitionType } from '@enums/partition-type.enum';

@Component({
    selector: 'app-datatables',
    templateUrl: './datatables.component.html',
    styleUrls: ['./datatables.component.scss']
})
export class DatatablesComponent implements OnInit {
    @Input() simulation: Simulation;

    private derogationProviderCode = 'bbc2020';

    isGenerating: boolean;
    user: AuthUser;
    derogationLink: NavLink;

    constructor(
        private reportSrv: ReportService,
        private authSrv: AuthService,
        private navSrv: NavService
    ) { }

    ngOnInit() {
        this.user = this.authSrv.getAuthUser();
        if(this.simulation.providerCode === this.derogationProviderCode) {
            this.derogationLink = this.navSrv.getLinkFromRoute(['simulation', 'derogation'], 'edit');
        }
    }

    get isSimuEdited(): boolean {
        return this.simulation.partitions
        .some(p => p.simulationValues.flag === SimulationFlagType.modified
            || p.partitionDetails.partitionType === PartitionType.funding
            || p.partitionDetails.partitionType === PartitionType.invest
            || p.partitionDetails.partitionType === PartitionType.simulationFile
            );
    }

    onExport(isArticle: boolean): void {
        this.isGenerating = true;
        if(isArticle) {
            this.reportSrv.generateXlsArticles()
            .subscribe(() => {
                this.isGenerating = false;
            });
        } else {
            this.reportSrv.generateXlsFromSimu(this.simulation)
            .subscribe(() => {
                this.isGenerating = false;
            });
        }
    }
}
